<script>
import { defineComponent as _defineComponent } from "vue";
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, provide, inject, watch, nextTick, readonly } from "vue";
import { useIntersectionObserver } from "@vueuse/core";
import { useScrollApi } from "../composables/private/useScrollApi";
import {
  MagicScrollTarget,
  MagicScrollProgress,
  MagicScrollReturn
} from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicScrollScene",
  props: {
    from: { type: String, required: false, default: "top-bottom" },
    to: { type: String, required: false, default: "bottom-top" }
  },
  setup(__props) {
    const scrollReturn = inject(MagicScrollReturn, void 0);
    const scrollTarget = inject(MagicScrollTarget, void 0);
    if (!scrollTarget) {
      console.error("MagicScrollScene must be used within a MagicScrollProvider");
    }
    const progress = ref(0);
    const intersecting = ref(false);
    const elRef = ref(void 0);
    const { getCalculations, getProgress } = useScrollApi({
      child: elRef,
      parent: scrollTarget,
      from: __props.from,
      to: __props.to
    });
    async function calculate() {
      getCalculations();
      await nextTick();
      progress.value = getProgress();
    }
    watch(
      () => scrollReturn?.y.value,
      () => {
        if (intersecting.value) {
          calculate();
        }
      }
    );
    watch(
      () => scrollReturn?.y.value,
      () => {
        calculate();
      },
      { once: true }
    );
    useIntersectionObserver(
      elRef,
      ([{ isIntersecting }]) => {
        intersecting.value = isIntersecting;
        if (isIntersecting) {
          calculate();
        }
      },
      { rootMargin: "150% 0px 150% 0px", immediate: true }
    );
    provide(MagicScrollProgress, readonly(progress));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(
        "div",
        {
          ref_key: "elRef",
          ref: elRef,
          class: "magic-scroll-scene"
        },
        [
          _renderSlot(_ctx.$slots, "default", { progress: progress.value })
        ],
        512
        /* NEED_PATCH */
      );
    };
  }
});
</script>
